import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { LOGIN_SCREEN_ROUTE } from "../routes";

const StartScreen = () => {
  useEffect(() => {
    const auth = localStorage.getItem("pharmacyAuthToken");
    if (!auth) {
      if (process.env.NODE_ENV && process.env.NODE_ENV !== "development") {
        window.location.href = "https://e-mareez.com/";
      }
    }
  }, []);

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "80vh",
        }}
      >
        {/* <Link to={LOGIN_SCREEN_ROUTE} state={{ state: "doctor" }}>
          <Button variant="outlined">Doctor Login</Button>
        </Link>
        <Link to={LOGIN_SCREEN_ROUTE} state={{ state: "staff" }}>
          <Button variant="outlined">Staff Login</Button>
        </Link> */}
        <Link to={LOGIN_SCREEN_ROUTE} state={{ state: "clinic_owner" }}>
          <Button variant="outlined">Pharmacy Login</Button>
        </Link>
      </Box>
    </Container>
  );
};

export default StartScreen;
